exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-36bafed4] {\n  margin-top: 30px;\n}\n.buttons[data-v-36bafed4] {\n  display: flex;\n  justify-content: space-between;\n}\n.buttons .optionBtns .main[data-v-36bafed4] {\n  margin-left: 15px;\n}\n.information[data-v-36bafed4] {\n  display: flex;\n  justify-content: space-between;\n}\n.information div[data-v-36bafed4] {\n  width: 50%;\n}", ""]);

// exports
